import React from 'react';
import About from '../components/About';
import Clients from '../components/Clients';
import FeatureCards from '../components/FeatureCards';
import Footer from '../components/Footer';
import Header from '../components/Header/Header';
import Stats from '../components/Stats';
import IndexPage from '../components/IndexPage';
import SecondaryAbout from '../components/SecondaryAbout';

const AboutPage = () => {
    return (
        <>
            <Header />
            <SecondaryAbout />
            <Stats />
            <Clients />
            <FeatureCards />
            <Footer />
        </>
    )
}

export default AboutPage;